<template>
  <md-dialog :md-active.sync="active">
    <md-dialog-title>{{ message }}</md-dialog-title>
    <md-dialog-content>{{ subMessage }}</md-dialog-content>
    <md-dialog-actions>
      <md-button @click="cancel">{{ buttonTextCancel }}</md-button>
      <md-button class="md-primary md-raised" @click="ok">{{ buttonTextOk }}</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import Component from 'vue-class-component'
import BaseDialog from '@/components/dialogs/BaseDialog'

/**
 * 「はい」「いいえ」選択用ダイアログ
 *
 * 使い方
 *
 * ```javascript
 * this.$dialog
 *   .open(ConfirmationDialog, {
 *     message: "削除してよろしいですか？",
 *     subMessage: `「${cluster.name}」`
 *   })
 *   .pipe(filter(response => response))
 *   .subscribe(() => {
 *     this.$store.dispatch("clusters/delete");
 *   });
 * ```
 */
@Component({
  props: {
    /**
     * メインメッセージ
     *
     * 操作の種類、Yes/No部分の確認内容はここに記載する。
     * 例）xxxxxを削除します。
     */
    message: String,
    /**
     * 補助メッセージ
     *
     * 詳細や列挙項目等はここに記載する。
     */
    subMessage: String,
    /**
     * キャンセル操作ボタンのテキスト
     *
     * 独自で設定したい場合は指定可能。
     */
    buttonTextCancel: {
      type: String,
      default: 'キャンセル',
    },
    /**
     * OK操作ボタンのテキスト
     *
     * 独自で設定したい場合は指定可能。
     */
    buttonTextOk: {
      type: String,
      default: 'はい',
    },
  },
})
export default class ConfirmationDialog extends BaseDialog {
  /**
   * 「はい」選択
   */
  ok() {
    this.hide(true)
  }

  /**
   * 「いいえ」選択
   */
  cancel() {
    this.hide(false)
  }
}
</script>

<style lang="scss" scoped>
.md-dialog {
  z-index: 1000;
}
.md-overlay {
  z-index: 100;
}
</style>
